/* eslint-disable import/no-unresolved */
/* eslint-disable max-classes-per-file */
// eslint-disable-next-line import/no-unresolved
/* globals DISABLE_LOCALIZATION */
import React from 'react'

import { FronthubProvider } from 'front-hub-context-api'
import { parseToSafeJson } from '../../../../core/security'
import contextHubApi from '../context-hub-api'
import { useHistory } from '../use-history'

/**
 * Render the root component encapsulating all the contexts (routers, data, i18next)
 * @param {object} context - FrontHub context
 * @param {function} Component - Component to be rendered
 * @param {class} Router - Virtual Router (react-router-dom)
 * @param {object} addon - An object containing all addon configuration
 * @returns JSX Element
 */
export default function rootComponentFactory(
  context,
  Component,
  Router,
  addon,
) {
  const history = useHistory()
  const contextPublicApi = contextHubApi(context)
  const { intlFormatting } = addon

  if (!DISABLE_LOCALIZATION) {
    // eslint-disable-next-line global-require
    Component = require('../with-i18n').default(
      Component,
      context,
      intlFormatting,
    ) // tree shaking
  }

  return ({ params }) => (
    <Router history={history}>
      <FronthubProvider value={contextPublicApi}>
        <Component {...parseToSafeJson(params)} />
      </FronthubProvider>
    </Router>
  )
}
